module.exports = __webpack_public_path__ + "img/img-a08bc7d6.d5088e04.png";